import { render, staticRenderFns } from "./ModalBranchEdit.vue?vue&type=template&id=6f920b69&scoped=true&lang=pug"
import script from "./ModalBranchEdit.vue?vue&type=script&lang=ts"
export * from "./ModalBranchEdit.vue?vue&type=script&lang=ts"
import style0 from "./ModalBranchEdit.vue?vue&type=style&index=0&id=6f920b69&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f920b69",
  null
  
)

export default component.exports